import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";
import {PropositionBetsWidgetRowOption} from "./proposition-bets-widget.row.option";

export const PropositionBetsWidgetRowOptions = observer(({controller, row}) => {
  return (
    <div className={classNames(styles.options, {[styles.single_option]: row.options.length === 1})}>
      {
        row.options?.map(option => <PropositionBetsWidgetRowOption row={row}
                                                                   key={option.name}
                                                                   option={option}
                                                                   controller={controller}
                                                                   hasThreeOption={row.options.length === 3}
        />)
      }
    </div>
  )
});
